import moment from 'moment';
import {addLocale} from 'primereact/api';
import {Calendar} from 'primereact/calendar';
import PropTypes from 'prop-types';
import React from 'react';
import BaseInputComponent from './BaseInputComponent';

class InputCalendarRangeComponent2 extends BaseInputComponent {


    renderView() {
        const {
            colClass,
            dateFormatMoment,
            id,           
            insideTable,
            label,
            showLabel,
            value,
            validateViewMode,
            validator,
            validators,
        } = this.props;
        return (
            <div className={insideTable ? '' : colClass}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        {label !== undefined && showLabel ? (
                            <label idFrom={`${id}-label-id`} className='p-label' htmlFor={id} style={{width: '100%'}}>
                                {label} 
                            </label>
                        ) : null}
                        <span aria-label={label} aria-labelledby={`${id}-label-id`} className='p-inputtext-view'>
                            {value && value.length>0 && value[0] ? moment(value[0]).format(dateFormatMoment) : ''}
                        </span>
                        <span className='px-2'>-</span>
                        <span aria-label={label} aria-labelledby={`${id}-label-id_to`} className='p-inputtext-view'>
                            {value && value.length>1 && value[1] ? moment(value[1]).format(dateFormatMoment) : ''}
                        </span>
                       
                    </div>
                   
                </div>
            </div>
        );
    }

    renderEdit(pl) {
        return this.renderNew(pl);
    }

    renderNew(pl) {
        const {
            colClass,
            dateFormat,
            disabled,
            from,
            value,
            id,            
            insideTable,
            label,
            labelFrom,
            name,
            minDateFrom,
            onAfterStateChange,
            onChange,
            placeholder,
            readOnlyInput,
            showIcon,
            stateField,
            validator,
            validators,          
            monthNavigator,
            yearNavigator,
            showTime,
            timeOnly,
            validateOnChange,
        } = this.props;
     
         const today = new Date();
         const yearRange =
             today.getFullYear() - 1 + ':' + new Date(today.getFullYear() + 20, today.getMonth(), today.getDate()).getFullYear();
        const requiredFrom = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
         const info = '. Aby przejść do edycji kolejnego pola kliknij Esc następnie Tab';
         const viewDateFrom = from || new Date();
        return (
            <div className={insideTable ? '' : colClass} id={id}>
                <div className={insideTable ? '' : 'row'}>
                    <div className={insideTable ? '' : 'col-md-12 form-group'}>
                        <div className='row'>
                        <div className='col-md-12'>
                                <span id={`${id}-label-id`} className='p-label' style={{width: '50%'}}>
                                  {(validators.includes('not_required')  ?  label : <label className='p-label'> {label}<label className='p-label-red'>{'*'}</label></label>  )}
                                </span>
                                <Calendar 
                                    selectionMode="range"
                                    ariaDescribedBy={`${id}-error`}
                                    ariaLabel={`${label} ${labelFrom} - data w formacie ${placeholder}${info}`}
                                    key={id}
                                    id={id}                                    
                                    name={name}
                                    style={{width: '100%'}}
                                    value={value}                                    
                                    onChange={(e) => onChange('CALENDAR_RANGE', undefined, e, onAfterStateChange, stateField)}
                                    readOnlyInput={readOnlyInput}
                                    locale={sessionStorage.getItem('i18nextLng')}
                                    dateFormat={dateFormat}
                                    placeholder={placeholder}
                                    showIcon={showIcon}
                                    disabled={disabled}
                                    className=''
                                    monthNavigator={monthNavigator}
                                    yearNavigator={yearNavigator}
                                    yearRange={yearRange}
                                    required={requiredFrom}
                                    showTime={showTime}
                                    timeOnly={timeOnly}
                                    minDate={minDateFrom && validateOnChange ? minDateFrom : undefined}
                                    viewDate={viewDateFrom} 
                                />
                                   <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                        </div>


                            
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    render() {
        const {rendered, viewMode} = this.props;
        const pl = {
            today: 'Dzisiaj',
            clear: 'Wyczyść',
            monthNames: [
                'Styczeń',
                'Luty',
                'Marzec',
                'Kwiecień',
                'Maj',
                'Czerwiec',
                'Lipiec',
                'Sierpień',
                'Wrzesień',
                'Październik',
                'Listopad',
                'Grudzień',
            ],
            monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
            dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
            dayNamesShort: ['Nie', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'So'],
            dayNamesMin: ['N', 'P', 'W', 'Ś', 'Cz', 'Pt', 'S'],
            firstDayOfWeek: 1,
        };
        if (rendered) {
            switch (viewMode) {
                case 'NEW':
                    return this.renderNew(pl);
                case 'EDIT':
                    return this.renderEdit(pl);
                case 'VIEW':
                default:
                    return this.renderView();
            }
        } else {
            return null;
        }
    }
}

addLocale('pl', {
    firstDayOfWeek: 1,
    dayNames: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
    dayNamesMin: ['N', 'P', 'W', 'Ś', 'Cz', 'Pt', 'S'],
    monthNames: [
        'Styczeń',
        'Luty',
        'Marzec',
        'Kwiecień',
        'Maj',
        'Czerwiec',
        'Lipiec',
        'Sierpień',
        'Wrzesień',
        'Październik',
        'Listopad',
        'Grudzień',
    ],
    monthNamesShort: ['Sty', 'Lut', 'Mar', 'Kwi', 'Maj', 'Cze', 'Lip', 'Sie', 'Wrz', 'Paź', 'Lis', 'Gru'],
    today: 'Dzisiaj',
    clear: 'Wyczyść',
});

InputCalendarRangeComponent2.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    dateFormat: 'dd-mm-yy',
    dateFormatMoment: 'DD-MM-YYYY',
    disabled: false,
    insideTable: false,
    labelFrom: 'Od',
    labelTo: 'Do',
    placeholder: 'dd-mm-rrrr',
    placeholderTo: 'dd-mm-rrrr',
    rendered: true,
    maxDate: undefined,
    readOnlyInput: false,
    showIcon: false,
    showLabel: true,
    stateField: 'element',
    validateViewMode: false,
    validators: 'required|date|date_format:DD-MM-YYYY,dd-mm-rrrr',
    viewMode: 'VIEW',
    monthNavigator: true,
    yearNavigator: true,
    showTime: false,
    timeOnly: false,
    validateOnChange: true,
};

InputCalendarRangeComponent2.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    colClass: PropTypes.string,
    dateFormat: PropTypes.string,
    dateFormatMoment: PropTypes.string,
    disabled: PropTypes.bool,
    insideTable: PropTypes.bool,
    label: PropTypes.string.isRequired,
    minDateFrom: PropTypes.instanceOf(Date),
    monthNavigator: PropTypes.bool,
    nameFrom: PropTypes.string.isRequired,
    nameTo: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    placeholderTo: PropTypes.string,
    readOnlyInput: PropTypes.bool,
    rendered: PropTypes.bool,
    showIcon: PropTypes.bool,
    showLabel: PropTypes.bool,
    maxDate: PropTypes.instanceOf(Date),
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.oneOfType(PropTypes.array, PropTypes.object).isRequired,
    validators: PropTypes.string,
    viewMode: PropTypes.string,
    yearNavigator: PropTypes.bool,
    showTime: PropTypes.bool,
    timeOnly: PropTypes.bool,
    validateOnChange: PropTypes.bool,
};

export default InputCalendarRangeComponent2;
